define([
	"csi/def/Heading",
	"csi/def/ViewFactory",
	"csi/table/matrix/Path",
	"csi/view",

	"csi/chart/View",
	"csi/datasheet/View",
	"csi/form/View",
	"csi/gallery/View",
	"csi/html/View",
	"csi/property/View",
	"csi/slicer/View",
	"csi/table/SwitchboardView",
	"csi/table/View",
	"csi/tabs/View",
	"csi/wizard/View"
], function(Heading, ViewFactory, PathMatrix, csiView) {

	Heading.registerDefaultMatrixProcessor(PathMatrix);

	// setup views
	ViewFactory.register({
		"": "csi/def/View",
		Chart: "csi/chart/View",
		DataSheet: "csi/datasheet/View",
		Form: "csi/form/View",
		Gallery: "csi/gallery/View",
		Html: "csi/html/View",
		Property: "csi/property/View",
		Slicer: "csi/slicer/View",
		Table: "csi/table/View",
		TableSwitchboard: "csi/table/SwitchboardView",
		Tabs: "csi/tabs/View",
		Wizard: "csi/wizard/View",
		React: 'csi/react/View'
	});

	csiView.registerViews({
		Chart: "csi/chart/Widget",
		DataSheet: "csi/datasheet/Widget",
		Form: "csi/form/Widget",
		Gallery: "csi/gallery/Widget",
		Html: "csi/html/Widget",
		Property: "csi/property/Widget",
		Slicer: "csi/slicer/slicerWidget",
		Table: "csi/table/Widget",
		TableSwitchboard: "csi/table/SwitchboardWidget",
		Tabs: "csi/tabs/Widget",
		Wizard: "csi/wizard/Widget"
	});
});